<div class="row">
  <div class="card shadow-none rounded">
    <div class="card-body">
      <div class="col-12 col-md-12 col-xxl-12 col-xl-12">
        <div class="row">
          <div class="col-12 col-xxl-10 col-xl-10 col-md-10 col-lg-10 col-sm-10">
            <h4 class="fw-bold">Provisions for liabilities - {{commonService.headerName}}</h4>
          </div>
          <div class="col-12 col-xxl-2 col-xl-2 col-md-2 col-lg-2 col-sm-2 text-start text-sm-end p-sm-0 pt-2">
            <button type="button" class="btn btn-outline-themecolorlight" style="padding: 7px;font-weight: 600; font-size: 14px;" tabindex="-1" (click)="TotalBack()">Close Accounts</button>
          </div>
        </div>
      </div>
      <hr />

      <div class="col-12 col-md-12 col-xxl-12 col-xl-12 col-lg-12  col-sm-12">
        <div class="row">
          <div class="col-12 col-xxl-12 col-xl-12 col-md-12 col-lg-12 col-sm-12">
            <!--<h5 class="fw-bolder font-size-16">Provisions for liabilities</h5>-->
            <div class="">
              <p class="mt-1">Please enter notes on any provisions for liabilities including movements during the year.</p>
              <p>If you do not have any notes to make, please return to the notes menu and de-select this section.</p>
            </div>
            <div class="col-xxl-11 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <form [formGroup]="CreateProvisionsForLiabilitiesFormGroup">
                <div class="row mt-4">
                  <div class="col-12 col-xxl-12 col-xl-12 col-lg-12 col-sm-12 col-md-12">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group">
                          <div class="row">
                            <div class="col-md-4  col-sm-12 col-12">
                              <div class="pt-2 mb-4">
                                <!--<h6 class="fw-bolder font-size-16">Indicates required field  <span class="text-danger">*</span></h6>-->
                              </div>
                            </div>
                            <div class="col-md-4  col-sm-6 col-12">
                              <div class="mb-2 text-center">
                                <!--<h6 class="mb-0 fw-bolder">At {{commonService.StartDate}}</h6>-->
                              </div>
                            </div>
                            <div class="col-md-4  col-sm-6 col-12">
                              <!--<div class="mb-2 text-center">
                                <h6 class="mb-0 fw-bolder">{{commonService.StartYear}}</h6>
                                <label>({{commonService.CAPeriodFrom}} to {{commonService.CAPeriodTo}})</label>
                              </div>-->
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 ps-0 ps-lg-5">

                        <div class="form-group">
                          <div class="row">
                            <div class="col-md-4  col-sm-12 col-12">
                              <div class="pt-2 mb-4">
                                <label class="m-t-5 font-weight-600"> At &nbsp; {{commonService.StartDate}}</label>
                              </div>
                            </div>
                            <div class="col-md-6  col-sm-6 col-12">
                              <div class="input-group mb-3">
                                <div class="input-group-text">
                                  <span class=" theme-color font-weight-600">£</span>
                                </div>
                                <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" maxlength="11" appNumberdirective placeholder="" formControlName="ProvisionsForLiabilitiesGrossStart" (blur)="Calculations()" />
                              </div>
                            </div>

                          </div>
                        </div>
                        <div class="form-group">
                          <div class="row">
                            <div class="col-md-4  col-sm-12 col-12">
                              <div class="pt-2 mb-4">
                                <label class="m-t-5 font-weight-600">Transfers from the profit and loss account</label>
                              </div>
                            </div>
                            <div class="col-md-6  col-sm-6 col-12">
                              <div class="input-group mb-3">
                                <div class="input-group-text">
                                  <span class=" theme-color font-weight-600">£</span>
                                </div>
                                <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" maxlength="11" appNumberdirective placeholder="" formControlName="TransfersFromTheProfitAndLossAccount" (blur)="Calculations()" />
                              </div>
                            </div>

                          </div>
                        </div>
                        <div class="form-group">
                          <div class="row">
                            <div class="col-md-4  col-sm-12 col-12">
                              <div class="pt-2 mb-4">
                                <label class="m-t-5 font-weight-600">Utilisation of provision</label>
                              </div>
                            </div>
                            <div class="col-md-6  col-sm-6 col-12">
                              <div class="input-group mb-3">
                                <div class="input-group-text">
                                  <span class=" theme-color font-weight-600">£</span>
                                </div>
                                <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" maxlength="11" appNumberdirective placeholder="" formControlName="UtilisationOfProvision" (blur)="Calculations()" />
                              </div>
                            </div>

                          </div>
                        </div>
                        <div class="form-group">
                          <div class="row">
                            <div class="col-md-4  col-sm-12 col-12">
                              <div class="pt-2 mb-4">
                                <label class="m-t-5 font-weight-600">At &nbsp;  {{commonService.EndDate}}</label>
                              </div>
                            </div>
                            <div class="col-md-6  col-sm-6 col-12">
                              <div class="input-group mb-3">
                                <div class="input-group-text">
                                  <span class=" theme-color font-weight-600">£</span>
                                </div>
                                <input type="text" class="form-control text-end" placeholder="" row="6" formControlName="GrossEnd" />
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--<div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="col-lg-12 mt-2">
                      <label>&nbsp;</label>
                    </div>
                    <div class="col-lg-12 mt-2">
                      <label class="font-size-16">At {{commonService.StartDate}}</label>
                    </div>
                    <div class="col-lg-12 mt-1">

                    </div>
                    <div class="col-lg-12 mt-2">
                      <label class="font-size-16">Transfers from the profit and loss account</label>
                    </div>
                    <!--<div class="col-lg-12 mt-0">
                      <label>&nbsp;</label>
                    </div>
                    <div class="col-lg-12 mt-2">
                      <label class="font-size-16">Utilisation of provision</label>
                    </div>
                    <!--<div class="col-lg-12 mt-0">
                      <label>&nbsp;</label>
                    </div>
                    <div class="col-lg-12 mt-2">
                      <label class="font-size-16">At {{commonService.EndDate}}</label>
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="col-lg-12 text-center">
                      <label class="font-size-16">&nbsp;</label><br />
                      <label></label>
                    </div>
                    <div class="col-lg-12 mt-4 ">
                      <div class="input-group">
                        <div class="input-group-text ">£</div>
                        <input type="text" class="form-control AccountNumber text-end" maxlength="11" appNumberdirective placeholder="" formControlName="ProvisionsForLiabilitiesGrossStart" (change)="Calculations()" />
                      </div>
                    </div>
                    <div class="col-lg-12 mt-4 ">
                      <div class="input-group">
                        <div class="input-group-text ">£</div>
                        <input type="text" class="form-control AccountNumber text-end" maxlength="11" appNumberdirective placeholder="" formControlName="TransfersFromTheProfitAndLossAccount" (change)="Calculations()" />
                      </div>
                    </div>
                    <div class="col-lg-12 mt-4 ">
                      <div class="input-group mb-2">
                        <div class="input-group-text ">£</div>
                        <input type="text" class="form-control AccountNumber text-end" maxlength="11" appNumberdirective placeholder="" formControlName="UtilisationOfProvision" (change)="Calculations()" />
                      </div>
                    </div>
                    <div class="col-lg-12 mt-4 ">
                      <div class="input-group">
                        <div class="input-group-text ">£</div>
                        <input type="text" class="form-control text-end" placeholder=""  formControlName="GrossEnd" />
                      </div>
                    </div>
                  </div>-->
                  <!--<div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="col-lg-12 text-center">
                      <label class="font-size-16 fw-bolder">2021</label><br />
                      <label>(06/04/2021 to 06/06/2021)</label>
                    </div>
                    <div class="col-lg-12 mt-4">
                      <div class="input-group">
                        <div class="input-group-text ">£</div>
                        <input type="text" class="form-control" placeholder="" />
                      </div>
                    </div>
                    <div class="col-lg-12 mt-4">
                      <div class="input-group">
                        <div class="input-group-text ">£</div>
                        <input type="text" class="form-control" placeholder="" />
                      </div>
                    </div>
                    <div class="col-lg-12 mt-4">
                      <div class="input-group mb-2">
                        <div class="input-group-text ">£</div>
                        <input type="text" class="form-control" placeholder="" />
                      </div>
                    </div>
                    <div class="col-lg-12 mt-4">
                      <div class="input-group">
                        <div class="input-group-text ">£</div>
                        <input type="text" class="form-control text-end" placeholder="" value="0" disabled />
                      </div>
                    </div>
                  </div>-->
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-3">
                  <label>Please enter any additional information in the field below.</label>
                  <div class="mb-3">
                    <textarea class="form-control txt-area string" appNumberdirective [appTooltip]="showBubbledata" maxlength="4000" formControlName="AdditionalInformation" rows="5"></textarea>
                  </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="col-12 col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 text-end mt-4 pe-0">
            <button type="button" class="btn btn-outline-back p-1 ps-3 pe-3 me-2" (click)="On_Back()">Back</button>
            <button type="button" class="btn themedefault p-1 ps-3 pe-3 ms-1 me-0" (click)="On_Next()">Next</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
